import { useLang } from "@/i18n";
import { GALLERY } from "@/data";
import { Reveal, Kicker } from "@/components/Reveal";

const Gallery = () => {
  const { lang, t } = useLang();
  return (
    <section id="gallery" className="relative py-24 sm:py-32 scroll-mt-20" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <Reveal className="max-w-2xl">
          <Kicker>{t.gallery.kicker}</Kicker>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-slate-50">
            {t.gallery.title}
          </h2>
          <p className="mt-6 text-base sm:text-lg text-slate-400">{t.gallery.sub}</p>
        </Reveal>

        <div className="mt-16 columns-1 sm:columns-2 lg:columns-3 gap-6 [column-fill:_balance]">
          {GALLERY.map((g, i) => (
            <Reveal key={g.src + i} delay={(i % 3) * 0.1} className="mb-6 break-inside-avoid">
              <figure
                data-testid={`gallery-item-${i}`}
                className="group relative overflow-hidden rounded-2xl ring-1 ring-gold/15 hover:ring-gold/50 transition-all duration-500"
              >
                <img
                  src={g.src}
                  alt={`${g.name.en}, ${g.place.en}`}
                  loading="lazy"
                  className="w-full object-cover group-hover:scale-108 group-hover:scale-105 transition-transform duration-[1.4s] ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C10]/90 via-transparent to-transparent opacity-80 group-hover:opacity-100 transition-opacity" />
                <figcaption className="absolute bottom-0 inset-x-0 p-5 flex items-end justify-between">
                  <div>
                    <p className="font-display text-lg sm:text-xl text-slate-50">{g.name[lang]}</p>
                    <p className="text-xs uppercase tracking-[0.25em] text-gold/90 font-mono mt-1">{g.place[lang]}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
